/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {Map, List} from 'immutable';
import {setField} from '../../../common/lib/redux-fields/actions';
import {resetPosition} from '../../../common/components/keyboard/actions';

class Keyboard extends React.Component {

  state: State = {
    shift: false
  };

  static propTypes = {
    maxLength: React.PropTypes.number,
    setField: React.PropTypes.func,
    resetPosition: React.PropTypes.func,
    position: React.PropTypes.bool,
    focusId: React.PropTypes.string
  };

  constructor(props) {
    super(props);
    this.keyMap = this.keyMap.bind(this);
    this.clickShift = this.clickShift.bind(this);
    this.clickSpace = this.clickSpace.bind(this);
    this.clickBackspace = this.clickBackspace.bind(this);
    this.clickTab = this.clickTab.bind(this);
    this.clickDefault = this.clickDefault.bind(this);
    this.setVal = this.setVal.bind(this);
    this.isEnter = this.isEnter.bind(this);
    this.generateSpanButton = this.generateSpanButton.bind(this);
    this.generateEnterButton = this.generateEnterButton.bind(this);
  }

  setVal(key) {
    const {focusId, setField, position, resetPosition, maxLength} = this.props;
    const {shift} = this.state;

    if (!focusId) {
      if (!!shift) {
        this.setState({shift: false});
      }
      return;
    }

    const input = document.getElementById(focusId);
    let val = input.value;

    if (!!position) {
      val = '';
      resetPosition();
    }

    if (key === null) {
      val = val.slice(0, -1);
    } else {
      val = val.toString() + key.toString();
      if (typeof maxLength !== 'undefined' && val.length > maxLength) {
        val = val.substring(0, val.length - 1);
      }
    }

    document.getElementById(focusId).focus();
    setField(focusId, val);
    if (!!shift) {
      this.setState({shift: false});
    }
  }

  clickShift() {
    const {shift} = this.state;
    this.setState({shift: !shift});
  }

  clickSpace() {
    this.setVal(' ');
  }

  clickBackspace() {
    this.setVal(null);
  }

  clickTab() {

  }

  clickDefault(i) {
    const {shift} = this.state;
    const keyMap = this.keyMap();
    let key;
    if (shift) {
      key = !!keyMap.getIn([i, 'secondKey'])
        ? keyMap.getIn([i, 'secondKey'])
        : keyMap.getIn([i, 'firstKey']);
      if (key === 'undefined') {
        return;
      }
      if (key.match(/[a-z]/g)) {
        key = key.toUpperCase();
      }
    } else {
      key = keyMap.getIn([i, 'firstKey']);
    }
    if (key === 'undefined') {
      return;
    }

    this.setVal(key);
  }

  keyMap() {
    return List([
      Map({
        firstKey: '~',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '1',
        secondKey: '!',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '2',
        secondKey: '@',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '3',
        secondKey: '#',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '4',
        secondKey: '$',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '5',
        secondKey: '%',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '6',
        secondKey: '^',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '7',
        secondKey: '@',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '8',
        secondKey: '*',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '9',
        secondKey: '(',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '0',
        secondKey: ')',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '-',
        secondKey: '_',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '=',
        secondKey: '+',
        keyClass: 'color-white'
      }),
      Map({
        innerClass: 'view-s',
        keyClass: 'color-white',
        keySize: 'view-size-2',
        icon: 'backspace',
        keyAction: this.clickBackspace
      }),
      Map({
        keyClass: 'func no-char big-1',
        keySize: 'view-size-2'
      }),
      Map({
        firstKey: 'q',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'w',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'e',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'r',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 't',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'y',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'u',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'i',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'o',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'p',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '[',
        secondKey: '{',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: ']',
        secondKey: '}',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '\\',
        secondKey: '|',
        keyClass: 'color-white'
      }),
      Map({
        keySize: 'view-size-3'
      }),
      Map({
        firstKey: 'a',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 's',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'd',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'f',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'g',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'h',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'j',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'k',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'l',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: ';',
        secondKey: ':',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '\'',
        secondKey: '\"',
        keyClass: 'color-white'
      }),
      Map({
        innerClass: 'view-s',
        keyClass: 'color-greenLight enter',
        icon: 'enter',
        keySize: 'view-size-3'
      }),
      Map({
        keyClass: 'color-white shift keyboardClasic-key-shift',
        icon: 'long-arrow-alt-up',
        keySize: 'view-size-4',
        keyAction: this.clickShift
      }),
      Map({
        firstKey: 'z',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'x',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'c',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'v',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'b',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'n',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: 'm',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: ',',
        secondKey: '<',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '.',
        secondKey: '>',
        keyClass: 'color-white'
      }),
      Map({
        firstKey: '/',
        secondKey: '?',
        keyClass: 'color-white'
      }),
      Map({
        keyClass: 'color-white shift keyboardClasic-key-shift',
        keySize: 'view-size-4',
        icon: 'long-arrow-alt-up',
        keyAction: this.clickShift
      }),
      Map({
        keyClass: 'color-white',
        firstKey: ' ',
        keySize: 'view-size-space',
        keyAction: this.clickSpace
      })
    ]);
  }

  isEnter(key) {
    return !!key.get('keyClass') && key.get('keyClass').indexOf('enter') > -1;
  }

  generateEnterButton(key, i) {
    return (
      <div key={`key-${i}`} className={`keyboardClasic-key ${key.get('keySize')}`}>
        <div
          className={`boxBtn text-l ${key.get('keyClass')}`}
          onClick={this.onSubmit}>
          <div className="boxBtn-inner">
            {!!key.get('icon') &&
            <svg className={`shape shape-${key.get('icon')}`}>
              <use xlinkHref={`#shape-${key.get('icon')}`}></use>
            </svg>
            }
            {!key.get('icon') && !!key.get('firstKey') &&
            <span className={`${key.get('innerClass')}`}>{key.get('firstKey')}</span>
            }
          </div>
        </div>
      </div>
    );
  }

  generateSpanButton(key, i) {
    const action = !!key.get('keyAction')
      ? key.get('keyAction')
      : this.clickDefault;

    return (
      <div key={`key-${i}`} className={`keyboardClasic-key ${key.get('keySize')}`}>
        <div
          className={`boxBtn text-l ${key.get('keyClass')}`}
          onClick={() => action(i)}
        >
          {!!key.get('icon') &&
          <div className="boxBtn-inner">
            <svg className={`shape shape-${key.get('icon')}`}>
              <use xlinkHref={`#shape-${key.get('icon')}`}></use>
            </svg>
          </div>
          }
          {!key.get('icon') && !!key.get('secondKey') &&
          <div className="boxBtn-inner">
            {!!key.get('firstKey') &&
            <span className="keyboardClasic-key-first">{key.get('firstKey')}</span>
            }
            {!!key.get('secondKey') &&
            <span className="keyboardClasic-key-second">{key.get('secondKey')}</span>
            }
          </div>
          }
          {!key.get('icon') && !key.get('secondKey') &&
          <div className="boxBtn-inner">
            {!!key.get('firstKey') &&
            <span className={`keyboardClasic-key-only ${key.get('innerClass')}`}>{key.get('firstKey')}</span>
            }
          </div>
          }
        </div>
      </div>
    );
  }

  render() {
    const keyMap = this.keyMap();
    const {shift} = this.state;

    return (
      <div className={`keyboardClasic ${shift ? 'shift' : ''}`}>
        {keyMap.map((key, i) => {
          if (this.isEnter(key)) {
            {
              return this.generateEnterButton(key, i)
            }
          } else {
            {
              return this.generateSpanButton(key, i)
            }
          }
        })}
      </div>
    );
  }
}

export default connect(state => ({
  focusId: state.keyboard.get('focusId'),
  position: state.keyboard.get('position')
}), {setField, resetPosition})(Keyboard);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/Keyboard.js